import Util from '../libs/util';
import TitleMappingUtil from '../views/title_mapping/libs/util';
import handle_hash from './handle_async_data/index'
const { ContractTypeClass, TeamCompanyMappingClass, CompanyTeamMappingClass } = handle_hash

// 组件中使用 this.$store.getters['async/xxx'] 获取
// 例:
// 1. 通过 this.$store.getters['async/root_teams'] 获取根团队数据
// 2. 通过 mapGetters 获取数据
// ...mapGetters( 'async', {
//   root_teams: 'root_teams',
//   companies: 'companies',
//   companies_hash: 'companies_hash',
// })
// ...mapGetters( 'async', ['jobs', 'teams_hash'])
// 在后端 app/models/util/async_data_util.rb 中定义以下 key 对应数据的获取逻辑

/*
* async_data = {
*   items: {
*     default: [],
*     // hash 定义如何生成 hash (非必填)
*     // 默认生成 items_hash
*     // items 中的 id 作为 hash 的 key
*     hash: {key: 'id'},
*     // 通过将 items 中的 item 传入 function 返回一个处理后的 key
*     hash: {key: function},
*     // 多个 hash, 需指定 hash 的 name
*     hash: [
*       {key: 'id', name: 'items_hash1'},
*       {key: function, name: 'items_hash2'},
*     ]
*   }
* }
* */


const ARRAY_DEFAULT = {
  default: [],
  hash: {key: 'id'}
}
const async_data = {
  cur_customer: {
    default: { groups: [] }
  },
  customer_types: {
    default: [],
    hash: {key: 'value'}
  },
  mapping_customer_types: {
    default: [],
    hash: {key: 'value'}
  },
  teams_tree: ARRAY_DEFAULT,
  companies: ARRAY_DEFAULT,
  root_teams: ARRAY_DEFAULT,
  teams: ARRAY_DEFAULT,
  jobs: ARRAY_DEFAULT,
  // 使用中的岗位
  in_use_jobs: ARRAY_DEFAULT,
  team_jobs_hash: {
    default: {}
  },
  offices: ARRAY_DEFAULT,
  warehouses: ARRAY_DEFAULT,
  expense_types: ARRAY_DEFAULT,
  banks: ARRAY_DEFAULT,
  clients: ARRAY_DEFAULT,
  currencies: ARRAY_DEFAULT,
  product_teams: ARRAY_DEFAULT,
  income_bill_types: ARRAY_DEFAULT,
  job_sequences:  ARRAY_DEFAULT,
  receipt_bill_types: {
    default: [],
    hash: {key: 'uid'}
  },
  receipt_purposes: ARRAY_DEFAULT,
  unit_types: {
    default: [],
    hash: {key: 'uid'}
  },
  expense_natures: ARRAY_DEFAULT,
  customer_functions: ARRAY_DEFAULT, // 职能
  item_types: ARRAY_DEFAULT, // 产品列表
  account_leaf_titles: ARRAY_DEFAULT, // 会计科目
  analysis_leaf_titles: ARRAY_DEFAULT, // 分析科目
  fund_usages: ARRAY_DEFAULT,
  account_titles: ARRAY_DEFAULT,
  analysis_titles: ARRAY_DEFAULT,
  opening_shop_materials: ARRAY_DEFAULT,
  employment_types: {
    default: [],
    hash: [{
      key: 'item_id',
      name: 'employment_types_item_id_hash',
     //  construction: CompanyTeamMappingClass
    }],
    
  },
  employment_forms: {
    default: [],
    hash: [{
      key: 'item_id',
      name: 'employment_forms_item_id_hash',
     //  construction: CompanyTeamMappingClass
    }],
  },
  outsource_contract_title_mappings: ARRAY_DEFAULT,
  sales_employment_types:  {
    default: [],
    hash: {key: 'item_id'}
  },
  team_company_mapping: {
    default: [],
    hash: [{
      key: 'company_id',
      name: 'team_company_mapping_hash',
      construction: TeamCompanyMappingClass
    }, {
      key: 'team_id',
      name: 'company_team_mapping_hash',
      construction: CompanyTeamMappingClass
    }],
    
  },
  contract_types: {
     default: [],
    hash: {
      key: 'id',
      construction: ContractTypeClass
    }
  },
  title_mappings: {
    default: [],
    hash: [
      {
        name: 'title_mappings_hash',
        key: 'id'
      },
      {
        name: 'title_mapping_ids_hash',
        key: (obj) => (TitleMappingUtil.functionHashName(obj))
      }
    ]
  },
  fin_bill_kinds: {
    default: [],
    hash: {key: 'value'}
  }
};

// 通过已有数据计算后得到的数据
const calc_data = {};
// 批量转成 hash 值, {id1: obj2, id2: obj2, ...}
// * 可通过 getter['async/key_hash'] 获取
for (const key in async_data) {
  const data_define = async_data[key];
  const hash_define = Util.clone(data_define['hash']);
  if (!hash_define) continue;
  const hash_define_list = []
  if (hash_define instanceof Array) {
    hash_define.forEach((d) => {
      if (!d.name) throw `${key} 请指定 hash name`;
      hash_define_list.push(d);
    })
  } else if (typeof hash_define === 'object') {
    if (!hash_define.name) {
      hash_define.name = `${key}_hash`
    }
    hash_define_list.push(hash_define);
  } else {
    throw 'hash 定义有误，请检查';
  }
  /*
    通过数组getter生成hash getter
  */
  hash_define_list.forEach((d) => {
    calc_data[d.name] = (state, getters) => {
      const key_value = d.key;
      if (d.construction) {
        const Construction = d.construction
        return new Construction(getters[key], key_value)
      }
    //  console.log('getters[key]', getters[key])
      const items = (getters[key] || []).map((obj) => {
        let hash_key = obj[key_value];
        if (typeof key_value === 'function') {
          hash_key = key_value(obj);
        }
        return { [hash_key]: obj };
      });
      return items.length ? Object.assign(...items) : {};
    }
  })
}
export const ASYNC_DATA = async_data;
export const CALC_DATA = calc_data;
